import React from 'react'

const About4 = (props) => {

    return (
        <section className="about-page-section section-padding">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col col-lg-8 col-md-10">
                        <div className="section-title-s3">
                            <span>#About us</span>
                            <h2>When <span>hope is hungry</span>, every helping hand feeds it.</h2>
                            <p>For over five years, Roslindale Food Collective, founded by Leah Arteaga, has been a beacon of hope in our community. What started as a small initiative to address food insecurity has grown into a robust network of volunteers dedicated to collecting and donating food to those in need. Every Sunday at 3pm, we come together to make a difference, one box of food at a time. Our journey is a testament to the power of collective effort and the compassion of our volunteers, who have been instrumental in turning Leah's vision into a reality.</p>
                        </div>
                    </div>
                </div>

                <div className="row">
    <div className="col col-xs-12">
        <div className="about-features-grid">
            <div className="grid">
                <div className="icon">
                    <i className="fi flaticon-donation"></i>
                </div>
                <h3>Donation</h3>
                <p>Your contributions support our goal to end food scarcity. Each donation is a step towards a community where everyone has enough.</p>
            </div>
            <div className="grid">
                <div className="icon">
                    <i className="fi flaticon-fruits"></i>
                </div>
                <h3>Food Distribution</h3>
                <p>We gather weekly to provide fresh, nutritious food. Our collective effort ensures that no one in our community goes hungry.</p>
            </div>
            <div className="grid">
                <div className="icon">
                    <i className="fi flaticon-charity"></i>
                </div>
                <h3>Community</h3>
                <p>At our core is a network of volunteers and donors passionate about making a positive change, one box of food and one smile at a time.</p>
            </div>
            {/* <div className="grid">
                <div className="icon">
                    <i className="fi flaticon-charity"></i>
                </div>
                <h3>Support</h3>
                <p>We provide a backbone of support for those in need, ensuring everyone has access to necessary resources to live well.</p>
            </div> */}
            <div className="grid">
                <div className="icon">
                    <i className="fi flaticon-smile"></i>
                </div>
                <h3>Hope</h3>
                <p>Our mission goes beyond food; we aim to inspire hope and create brighter futures through care, sharing, and support.</p>
            </div>
            <div className="grid">
                <div className="icon">
                    <i className="fi flaticon-like"></i>
                </div>
                <h3>Empathy</h3>
                <p>Empathy drives us to understand and address the challenges of those we serve, uniting us in our mission for a better world.</p>
            </div>
        </div>
    </div>
</div>

            </div>
        </section>
    )
}

export default About4;
